<p-dialog *transloco="let t;" header="Header" [(visible)]="visible" [breakpoints]="{ '1080px': '75vw', '560px':'90vw' }"
    [style]="{ width: '50vw' }" (onHide)="onHide()" class="packages-modal"  [modal]="true"  [dismissableMask]="true">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold text-white">{{t('merchandise.refillWallet')}}</span>
    </ng-template>
    <div class="flex flex-wrap gap-3 place-content-center">
        <k-package-card *ngFor="let packageData of packageCardsData" [data]="packageData"
            (onCardClick)="onCardClick($event)"></k-package-card>
    </div>
</p-dialog>

<onramper [visible]="showOnramper" [kmonPriceData]="kmonPriceData" (isVisible)="showOnramper=$event"
    [amountSelected]="amountSelectedOnramper" [wallet]="wallet"></onramper>